import { useNavigate } from 'react-router-dom';
import { SupplierFeedList } from './supplier-feed-list.component';

export function SupplierFeedsTab() {
  const navigate = useNavigate();

  return (
    <SupplierFeedList
      onSelect={(id) => navigate(`/i/admin/supplier-price-lists/${id}`)}
    />
  );
}
